import { cn } from "~/lib/utils";

export default function LoadingSpinner({
  containerClassName = "",
  spinnerClassName = "",
}: {
  containerClassName?: string;
  spinnerClassName?: string;
}) {
  return (
    <div role="status" className={cn("flex items-center justify-center", containerClassName)}>
      <div
        className={cn(
          "animate-spin rounded-full h-6 w-6 border-b-2 border-primary",
          spinnerClassName,
        )}
      />
    </div>
  );
}
